// =================== STYLE CONSTANTS ===================
export const stylesImpressaoRetrospectivaCSS = {
    page: {
        padding: '16px',
        background: '#f5f5f5', minHeight: '100vh'
    },
    pageTitle: {
        marginBottom: '16px'
    },

    sprintButtonsRow: {
        display: 'flex',
        gap: '8px',
        marginBottom: '16px',
        flexWrap: 'wrap'
    },

    tabsRow: {
        display: 'flex',
        gap: '8px',
        marginBottom: '24px',
        flexWrap: 'wrap'
    },

    tabButton: (active: boolean) => ({
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        borderRadius: '8px',
        backgroundColor: active ? '#0d6efd' : '#e0e0e0',
        color: active ? '#fff' : '#333',
        border: 'none',
        cursor: 'pointer',
    }),

    sprintButton: (selected: boolean, activeColor = '#0d6efd') => ({
        padding: '8px 16px',
        borderRadius: '8px',
        border: 'none',
        backgroundColor: selected ? activeColor : '#e0e0e0',
        color: selected ? '#fff' : '#333',
    }),

    // Loader
    loaderContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '60vh', color: '#444',
        fontFamily: 'sans-serif', gap: '12px'
    },

    loaderDotsRow: {
        display: 'flex',
        gap: '6px'
    },

    dot: (delay?: string) => ({
        width: '10px',
        height: '10px',
        borderRadius: '50%',
        background: '#0d6efd',
        animation: 'bounce 0.6s infinite alternate', ...(delay ? {animationDelay: delay} : {})
    }),
    keyframes: `@keyframes bounce {from { transform: translateY(0); opacity: 0.6; } to { transform: translateY(-6px); opacity: 1; }}`,

    sprintOuterCard: {
        marginBottom: '24px',
        padding: '16px',
        border: '1px solid #ddd',
        borderRadius: '12px',
        background: '#fff'
    },

    sprintTitle: {
        marginBottom: '16px',
        fontSize: '23px'
    },

    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: '16px'
    },

    card: {
        background: 'rgba(252,253,202,0.21)',
        padding: '12px',
        borderRadius: '8px',
        boxShadow: '0 6px 8px rgba(0,0,0,0.05)',
        border: '1px solid #F0FDF4',
        borderLeft: '4px solid #b3a63e'
    },

    cardTitle: {
        margin: '0 0 4px 0',
        fontSize: '20px',
        fontWeight: 600 as const
    },
    cardValue: {margin: 0,
        fontWeight: 'bold',
        fontSize: '20px'
    },

    cardSubtitle: {
        fontSize: '16px',
        color: '#555'
    },

    statusRow: (color: string) => ({
        display: 'flex',
        alignItems: 'center',
        color
    }),

    iconMarginRight: {marginRight: '6px'},

    chartWrapper: {
        marginTop: '24px',
        background: '#fff',
        borderRadius: '12px',
        boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
        padding: '16px'
    },
    chartTitle: {
        marginBottom: '16px',
        fontSize: '18px'
    },

    // Discussão
    discussBox: (color: string, bg: string) => ({
        marginBottom: '16px',
        padding: '16px',
        borderLeft: `4px solid ${color}`,
        background: bg,
        borderRadius: '8px',
    }),

    discussQuestion: (color: string) => ({
        fontSize: '23px',
        fontWeight: 600,
        color,
        marginBottom: '8px',
    }),

    discussContext: {
        fontSize: '20px',
        color: '#444',
    },
    discussContextLabel: {
        fontWeight: 600,
        marginRight: '4px',
    },

    // Métricas
    metricsContainer: {display: 'flex',
        flexDirection: 'column',
        gap: '24px'
    },

    metricsCard: {
        background: '#fff',
        borderRadius: '8px',
        padding: '16px',
        boxShadow: '0 5px 9px rgba(0,0,0,0.1)'
    },

    metricsTitle: {
        marginBottom: '12px',
        fontSize: '23px'
    },

    summaryWrap: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '12px',
        marginTop: '16px'
    },

    summaryItem: (bg: string) => ({
        flex: '1 1 calc(50% - 12px)',
        background: bg,
        padding: '12px',
        borderRadius: '8px',
        textAlign: 'center' as const
    }),

    summaryValue: (color: string) => ({
        fontSize: '22px',
        fontWeight: 700 as const,
        color
    }),

    summaryLabel: {
        fontSize: '16px',
        color: '#555'
    },

    metricsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2,1fr)',
        gap: '16px'
    },

    statRows: {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px'
    },

    statRow: {
        display: 'flex',
        justifyContent: 'space-between'
    },

    statValue: (color: string) => ({color, fontWeight: 600 as const}),
};
